export function localStorageExpires(): void {
  const toRemove: string[] = [];
  const currentDate = new Date().getTime();
  const keys = Object.keys(localStorage);

  keys.forEach((key) => {
    const current = localStorage.getItem(key);

    if (current && /^\{(.*?)\}$/.test(current)) {
      let currentObj;
      try {
        currentObj = JSON.parse(current) || {};
      } catch (e) {
        console.error('localStorageExpires', e);
      }

      if (currentObj?.expires <= currentDate) {
        toRemove.push(key);
      }
    }
  });

  if (toRemove.length) {
    console.info('🗑  Expired storage for keys: ', toRemove);
    toRemove.reverse().forEach((key) => localStorage.removeItem(key));
  }
}

export function setLocalStorage(key: string, value: unknown, minutes = 99999999999) {
  const expires = new Date().getTime() + 60000 * minutes;

  localStorage.setItem(key, JSON.stringify({ value, expires }));
}

export function removeLocalStorage(key: string) {
  localStorage.removeItem(key);
}

export function getLocalStorage(key: string, valueDefault = null) {
  localStorageExpires();

  const itemValue = localStorage[key];

  if (itemValue && /^\{(.*?)\}$/.test(itemValue)) {
    const current = JSON.parse(itemValue);

    return current.value;
  }

  return valueDefault;
}

localStorageExpires();

window.aguadecoco = window.aguadecoco || {};
Object.assign(window.aguadecoco, {
  helpers: Object.assign(window.aguadecoco.helpers || {}, {
    storage: {
      save: setLocalStorage,
      read: getLocalStorage,
      remove: removeLocalStorage,
      flush: localStorageExpires,
    },
  }),
});

export default {};
